import ReactGA from "react-ga4";

const GA_ID = process.env.REACT_APP_GA4_ID || "";
const isDev = process.env.NODE_ENV !== "production";

/* ======================
   INIT
====================== */
export function initGA() {
  if (!GA_ID) {
    console.warn("[GA] Missing REACT_APP_GA4_ID");
    return;
  }
  ReactGA.initialize(GA_ID);
}

/* ======================
   PAGE VIEW (SPA)
====================== */
export function trackPageView(path: string) {
  if (!GA_ID) return;

  ReactGA.send({
    hitType: "pageview",
    page: path,
  });
}

/* ======================
   GENERIC EVENT
====================== */
export function trackEvent(
  action: string,
  params?: Record<string, any>
) {
  if (!GA_ID) return;

  ReactGA.event(action, {
    ...params,
    ...(isDev ? { debug_mode: true } : {}),
  });
}

/* ======================
   GA4 ECOMMERCE
====================== */
export type GAItem = {
  item_id: string;
  item_name: string;
  price?: number;
  quantity?: number;
  item_brand?: string;
  item_category?: string;
  item_variant?: string;
};

/* --- view_item --- */
export function gaViewItem(payload: {
  currency: string; // "VND"
  value: number;
  item: GAItem;
}) {
  if (!GA_ID) return;

  ReactGA.event("view_item", {
    currency: payload.currency,
    value: payload.value,
    items: [
      {
        ...payload.item,
        quantity: 1,
      },
    ],
    ...(isDev ? { debug_mode: true } : {}),
  });
}

/* --- add_to_cart --- */
export function gaAddToCart(payload: {
  currency: string;
  value: number; // price * quantity
  quantity: number;
  item: GAItem;
}) {
  if (!GA_ID) return;

  ReactGA.event("add_to_cart", {
    currency: payload.currency,
    value: payload.value,
    items: [
      {
        ...payload.item,
        quantity: payload.quantity,
      },
    ],
    ...(isDev ? { debug_mode: true } : {}),
  });
}

/* --- purchase --- */
export function gaPurchase(payload: {
  transaction_id: string;
  currency: string;
  value: number; // tổng tiền
  shipping?: number;
  tax?: number;
  coupon?: string;
  items: GAItem[]; // PHẢI có quantity
}) {
  if (!GA_ID) return;

  ReactGA.event("purchase", {
    transaction_id: payload.transaction_id,
    currency: payload.currency,
    value: payload.value,
    shipping: payload.shipping,
    tax: payload.tax,
    coupon: payload.coupon,
    items: payload.items,
    ...(isDev ? { debug_mode: true } : {}),
  });
}
